import { useEffect } from "react";
import OrgAccountDetailsOnboardingForm from "./OrgAccountDetailsOnboardingForm";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function OrgAccountDetailsOnboardingStep({
  onComplete,
  onBack,
}: {
  onComplete: () => void;
  onBack?: () => void;
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      {onBack && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onBack}
          className="mb-4 -ml-2"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>
      )}
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-1 animate-fade-in">
          Account Details
        </h2>
        <p className="text-gray-600 mb-6 animate-fade-in-delay-2">
          Please enter your name to get started
        </p>
        <OrgAccountDetailsOnboardingForm onComplete={onComplete} />
      </div>
    </div>
  );
}
